export const SUB_STEP_ALIAS = (eventType) => ({
  1: 'eventAbout',
  2: 'eventOccasion',
  3: eventType === 'online' ? 'eventImage' : 'event_address',
  4: eventType === 'online' ? 'eventDescription' : 'eventMap',
  5: eventType === 'online' ? 'eventTermsAndConditions' : 'eventImage',
  6: eventType === 'online' ? null : 'eventDescription',
  7: eventType === 'online' ? null : 'eventTermsAndConditions',
  final: eventType === 'online' ? 5 : 7, // to indicate the sub step no of final step
});

export const VISIBILITY_OPTIONS = [
  {
    id: 'true',
    label: 'Public',
  },
  {
    id: 'false',
    label: 'Private',
  },
];

export const EVENT_TYPE_OPTIONS = [
  {
    id: 'offline',
    label: 'In person',
  },
  {
    id: 'online',
    label: 'Online',
  },
];

export const EVENT_CATEGORY = [
   {
     id: 'Music & Concerts',
     label: 'Music & Concerts',
   },
   {
     id: 'College & Campus Events',
     label: 'College & Campus Events',
   },
   {
     id: 'Community & Social Events',
     label: 'Community & Social Events',
   },
   {
     id: 'Workshops & Seminars',
     label: 'Workshops & Seminars',
   },
   {
     id: 'Parties & Nightlife',
     label: 'Parties & Nightlife',
   },
   {
     id: 'Theatre & Performing Arts',
     label: 'Theatre & Performing Arts',
   },
   {
     id: 'Others',
     label: 'Others',
   }

]
